var _style, _circle, _circle2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspacesLogoColour(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 326",
    style: {
      enableBackground: "new 0 0 400 326"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:none;stroke:#CBCBCB;stroke-miterlimit:10;}\r\n\t.st1{display:none;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:none;stroke:#CBCBCB;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{fill:#3699B1;}\r\n\t.st6{fill:#6A3163;}\r\n\t.st7{fill:#90A13C;}\r\n\t.st8{fill:#4A9569;}\r\n\t.st9{fill:#991D20;}\r\n\t.st10{fill:#0A4159;}\r\n\t.st11{fill:#F05927;}\r\n\t.st12{fill:#FFFFFF;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 200,
    cy: 163,
    r: 107.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 200,
    cy: 163,
    r: 74.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 107.8,
    y1: 219.9,
    x2: 167.8,
    y2: 182.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 232.1,
    y1: 143.4,
    x2: 292.6,
    y2: 106.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 105.5,
    y1: 110.1,
    x2: 167,
    y2: 144.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 232.9,
    y1: 181.3,
    x2: 294.9,
    y2: 215.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 257,
    y1: 255.4,
    x2: 220.1,
    y2: 195.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 180.5,
    y1: 131.1,
    x2: 143.3,
    y2: 70.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 147.2,
    y1: 257.7,
    x2: 181.6,
    y2: 196.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 218.5,
    y1: 130.3,
    x2: 253.1,
    y2: 68.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 200.2,
    y1: 54.5,
    x2: 200.2,
    y2: 125
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 200.2,
    y1: 200.5,
    x2: 200.2,
    y2: 271.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 91.7,
    y1: 163,
    x2: 162.2,
    y2: 163
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 237.7,
    y1: 163,
    x2: 308.7,
    y2: 163
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 275,
    y1: 238,
    x2: 125,
    y2: 88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 275,
    y1: 88,
    x2: 125,
    y2: 238
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 49.5,
    cy: 163,
    r: 47.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 315.9,
    cy: 273.2,
    r: 47.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 97,
    cy: 271.7,
    r: 36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 315.9,
    cy: 52.8,
    r: 47.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 97,
    cy: 55.7,
    r: 36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 362,
    cy: 163,
    r: 36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 205.5,
    cy: 163,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 205,
    cy: 163.7,
    r: 36
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M152.3,109.9c-4.9-4.3-9.6-8.8-14.4-13.2l-14.3-13.4c-4.8-4.5-9.8-8.6-14.1-13.5c-4.5-4.9-8.6-9.8-12.5-15.3 l0.3-0.3c5.5,3.7,10.4,8.1,15.3,12.5c4.9,4.5,9.1,9.4,13.5,14.1L139.5,95c4.5,4.9,8.9,9.6,13.2,14.4L152.3,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M258.5,109.6c4.3-4.9,8.8-9.6,13.2-14.4l13.4-14.3c4.5-4.8,8.6-9.8,13.5-14.1c4.9-4.5,9.8-8.6,15.3-12.5 l0.3,0.3c-3.7,5.5-8.1,10.4-12.5,15.3c-4.5,4.9-9.4,9.1-14.1,13.5l-14.3,13.4c-4.9,4.5-9.6,8.9-14.4,13.2L258.5,109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.6,162.9c7.1-1.2,14.1-1.6,21-2c7.1-0.3,14.1,0.3,21,0.4l21,0.6c7.1,0.3,14.1,0.6,21,0.9v0.4 c-7.1,0.3-14.1,0.6-21,0.9l-21,0.6c-7.1,0.1-14.1,0.7-21,0.4c-7.1-0.3-14.1-0.7-21-2C46.6,163,46.6,162.9,46.6,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M279.9,162.9c7.1-0.3,14-0.6,21-0.9l21-0.6c7.1-0.1,14.1-0.7,21-0.4c7.1,0.3,14.1,0.7,21,2v0.4 c-7.1,1.2-14.1,1.6-21,2c-7.1,0.3-14.1-0.3-21-0.4l-21-0.6c-7.1-0.3-14.1-0.6-21-0.9L279.9,162.9L279.9,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M258.9,216.1c4.9,4.3,9.6,8.8,14.4,13.2l14.3,13.4c4.8,4.5,9.8,8.6,14.1,13.5c4.5,4.9,8.6,9.8,12.5,15.3 l-0.3,0.3c-5.5-3.7-10.4-8.1-15.3-12.5c-4.9-4.5-9.1-9.4-13.5-14.1L271.7,231c-4.5-4.9-8.9-9.6-13.2-14.4L258.9,216.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M152.6,216.4c-4.3,4.9-8.8,9.6-13.2,14.4L126,245.1c-4.5,4.8-8.6,9.8-13.5,14.1c-4.9,4.5-9.8,8.6-15.3,12.5 l-0.3-0.3c3.7-5.5,8.1-10.4,12.5-15.3c4.5-4.9,9.4-9.1,14.1-13.5l14.3-13.4c4.9-4.5,9.6-8.9,14.4-13.2L152.6,216.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspacesLogoColour);
export default __webpack_public_path__ + "static/media/workspaces-logo-colour.f954a512e0b7778448f21eecb8507bb8.svg";
export { ForwardRef as ReactComponent };